import { ComplianceEntity } from "@wingspanhq/wingspan-api-sdk";

/**
 * The country the entity operates or resides in — the v3 stand-in for the v2
 * monitored entity's `country`. The physical address is the closest equivalent;
 * the jurisdiction is the fallback for an entity with no address on file.
 */
export const selectorComplianceEntityCountry = (
  entity: ComplianceEntity | undefined
): string | undefined =>
  entity?.physicalAddress?.country || entity?.jurisdictionCountry || undefined;
